<div class="a00010">
    <div class="container">
        <div id="linkWrapper">
            <a class="link" href="/">
                <img
                    class="backgroundImg"
                    [srcset]="srcsetValue"
                    sizes="(max-width: 991px) 104w, 148px"
                    [src]="'/IMG/mitsubishi-logo.png' | assetPath: 'dist/ng-presse'"
                    alt="Homelink Background"
                    />
                <img
                    class="logo"
                    title="Mitsubishi"
                    alt="Mitsubishi Logo"
                    [src]=" '/IMG/mitsubishi-logo.svg' | assetPath: 'dist/ng-presse'"
                    width="55"
                    height="60"
                />
            </a>
        </div>
    </div>
</div>
